import { useCallback, useEffect, useState } from 'react';
import { disablePush, enablePush, getPushSubscription, isPushSupported } from '../utils/push';

export type PushStatus = 'loading' | 'unsupported' | 'blocked' | 'enabled' | 'disabled';

export const usePushNotifications = () => {
  const [status, setStatus] = useState<PushStatus>('loading');
  const [busy, setBusy] = useState(false);

  const refresh = useCallback(async () => {
    if (!isPushSupported()) {
      setStatus('unsupported');
      return;
    }
    if (Notification.permission === 'denied') {
      setStatus('blocked');
      return;
    }
    const subscription = await getPushSubscription();
    setStatus(subscription ? 'enabled' : 'disabled');
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const enable = useCallback(async () => {
    setBusy(true);
    try {
      await enablePush();
      setStatus('enabled');
    } catch (error) {
      await refresh();
      throw error;
    } finally {
      setBusy(false);
    }
  }, [refresh]);

  const disable = useCallback(async () => {
    setBusy(true);
    try {
      await disablePush();
      setStatus('disabled');
    } finally {
      setBusy(false);
    }
  }, []);

  return { status, busy, enable, disable };
};
